import { MenuControllerId, MenuItem } from '@adaptiva/core/menus';
import { RoutingService } from '@adaptiva/core/routing';
import { EJavaClassNames, ServerObjectMenuController } from '@adaptiva/data-service';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CustomerServer } from '../../java';

@Injectable()
export class CustomerServerMenuController extends ServerObjectMenuController<CustomerServer> {

	public static override readonly id: MenuControllerId.Any = `${MenuControllerId.Prefix.Default}${EJavaClassNames.CustomerServer}`;

	public readonly viewDashboardMenuName: string = 'View Dashboard';

	protected readonly routingService: RoutingService = inject(RoutingService);

	public override getClassName(): string {
		return EJavaClassNames.CustomerServer;	
	}

	public override generate(_data: CustomerServer): Observable<MenuItem<CustomerServer>[]> {
		return super.generate(_data).pipe(
			map((_items: MenuItem<CustomerServer>[]) => {
				_items.push(this.getViewDashboardMenuItem(_data));

				return _items;
			})
		);
	}

	protected override enableSaveAs(_item: MenuItem<CustomerServer>): void {
		_item.isVisible.next(false);
	}

	protected getViewDashboardMenuItem(_server: CustomerServer): MenuItem<CustomerServer> {
		const _itemId: string = this.hashItem(this.viewDashboardMenuName, _server);
		const _item: MenuItem<CustomerServer> = this.getItem(_itemId, _server) || this.createItem({
			id: _itemId,
			name: this.viewDashboardMenuName,
			data: _server,
			onSelect: this.viewDashboard.bind(this)
		});

		return _item;
	}

	protected viewDashboard(_item: MenuItem<CustomerServer>): void {
		const _dashboardUrl: string = `/dashboards/user-dashboards/customer-server-details/${_item.data.objectId}`;

		this.routingService.navigateByUrl(_dashboardUrl);
	}

}
